import { InitialValues, SyncSettingsType } from "./types";

export const SYNC_SETTINGS_TYPES: SyncSettingsType = {
  empty: "",
  sinceLastSync: "sinceLastSync",
  allTransactions: "allTransactions",
};

export const INITIAL_VALUES: InitialValues = {
  firstIntegrationThroughDate: null,
  updateDateRange: "",
  customDate: null,
  syncSettings: SYNC_SETTINGS_TYPES.empty,
  capitalCalls: false,
  distributions: false,
  capitalActivity: false,
  netIncome: false,
  integrationStart: null,
  useInceptionDate: false,
  integrationThrough: null,
};
